<template>
    <div 
        class="pe_rotate-device" 
        v-if="landscape"
    >
        <div class="pe_phone"></div>
        <div class="pe_message">
          Please rotate your device.
        </div>
    </div> 
  </template>
  
  <script>
  
  export default {
  
    data() {
      return {
        landscape: false
      }
    }, 

    mounted() {
      // Find matches
      var mql = window.matchMedia("(orientation: landscape)")
  
      // If there are matches, we're in portrait
      this.landscape = mql.matches
  
      // Add a media query change listener
      mql.addEventListener("change", m => this.landscape = mql.matches);
    },
  }
  
  </script> 
  
  <style lang="scss">
  
  @import '~@puzzleapps/shared/src/style/globalStyles';
  
  </style>
  